import { BufferAttribute } from 'three/src/core/BufferAttribute';
import { BufferGeometry } from 'three/src/core/BufferGeometry';
import { Mesh } from 'three/src/objects/Mesh';
import { MeshPhongMaterial } from 'three/src/materials/MeshPhongMaterial';
import DxfParser from 'modules/project/ProjectAreaPage/ProjectStopesPage/DxfImporter/src/index';
import { ThreeDFaceEntity } from 'modules/project/ProjectAreaPage/ProjectStopesPage/DxfImporter/src/parser/entities/3dface/types';

const verticesAreEqual = (a: { x: number; y: number; z: number }, b: { x: number; y: number; z: number }) => a.x === b.x && a.y === b.y && a.z === b.z;

/** Triangle positions of every 3DFACE (quads split in two), still in float64. */
export const dxfFacePositions = (dxfContent: string): number[] => {
  const parser = new DxfParser();
  const dxfData = parser.parseSync(dxfContent);
  const entities = Array.isArray(dxfData.entities) ? dxfData.entities : [];

  const faces = entities.filter((e): e is ThreeDFaceEntity => e.type === '3DFACE');

  const positions: number[] = [];

  faces.forEach((face) => {
    const verts = face.vertices;
    if (!verts || verts.length < 3) return;

    positions.push(verts[0].x, verts[0].y, verts[0].z);
    positions.push(verts[1].x, verts[1].y, verts[1].z);
    positions.push(verts[2].x, verts[2].y, verts[2].z);

    if (verts.length >= 4 && !verticesAreEqual(verts[2], verts[3])) {
      positions.push(verts[0].x, verts[0].y, verts[0].z);
      positions.push(verts[2].x, verts[2].y, verts[2].z);
      positions.push(verts[3].x, verts[3].y, verts[3].z);
    }
  });

  return positions;
};

const parseDxfToMesh = (dxfContent: string): Mesh | null => {
  const positions = dxfFacePositions(dxfContent);
  if (positions.length === 0) return null;

  const geometry = new BufferGeometry();
  geometry.setAttribute('position', new BufferAttribute(new Float32Array(positions), 3));

  const material = new MeshPhongMaterial({
    color: 0x808080,
    transparent: true,
    opacity: 0.2,
  });

  const mesh = new Mesh(geometry, material);
  mesh.name = 'Initial Stope';

  return mesh;
};

export default parseDxfToMesh;
